var TYPES = {
  INLINE: "inline",
  NAVIGATION: "navigation"
};
export default TYPES;